// OOCL Australia/New Zealand service network.
// Source: OOCL "Product and Service Guide Australia/New Zealand 2024" (client-supplied eBook)
// + https://www.oocl.com/eng/ourservices/serviceroutes/aut/Pages/default.aspx
// Transit groups list [from, to, days].

export const OOCL_SOURCE_URL = "https://www.oocl.com/eng/ourservices/serviceroutes/aut/Pages/default.aspx";

export const OOCL_INTRO =
  "OOCL operates one of the leading service networks on the Asia\u2013Australia and Asia\u2013New Zealand tradelanes \u2014 " +
  "direct fixed-day weekly sailings from North Asia, China, Taiwan and South-East Asia, backed by an extensive intra-Asia " +
  "feeder network. The 11 Australia/NZ services below cover every mainland Australian port plus the major New Zealand ports.";

export const OOCL_SERVICES = [
  {
    code: "A3S", name: "Asia Australia Consortium \u2014 Southern Express", region: "Australia",
    freq: "Fixed-day weekly", round: "35-day round voyage", origins: ["Xiamen", "Hong Kong", "Shekou"],
    nb: ["Sydney", "Melbourne", "Brisbane", "Xiamen", "Hong Kong", "Shekou"],
    sb: ["Xiamen", "Hong Kong", "Shekou", "Sydney", "Melbourne", "Brisbane"],
    note: "South China loop \u2014 fastest ex-Shekou into Sydney (11 days).",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Xiamen", "Sydney", 14], ["Xiamen", "Melbourne", 18], ["Xiamen", "Brisbane", 22],
        ["Hong Kong", "Sydney", 12], ["Hong Kong", "Melbourne", 16], ["Hong Kong", "Brisbane", 20],
        ["Shekou", "Sydney", 11], ["Shekou", "Melbourne", 15], ["Shekou", "Brisbane", 19] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Sydney", "Xiamen", 18], ["Sydney", "Hong Kong", 20], ["Sydney", "Shekou", 21],
        ["Melbourne", "Xiamen", 15], ["Melbourne", "Hong Kong", 17], ["Melbourne", "Shekou", 18],
        ["Brisbane", "Xiamen", 11], ["Brisbane", "Hong Kong", 13], ["Brisbane", "Shekou", 14] ] },
    ],
  },
  {
    code: "A3N", name: "Asia Australia Consortium \u2014 Northern Express", region: "Australia",
    freq: "Fixed-day weekly", round: "42-day round voyage", origins: ["Yokohama", "Osaka", "Pusan", "Qingdao", "Shanghai", "Kaohsiung"],
    nb: ["Melbourne", "Sydney", "Brisbane", "Yokohama", "Osaka", "Pusan", "Qingdao", "Shanghai", "Kaohsiung"],
    sb: ["Yokohama", "Osaka", "Pusan", "Qingdao", "Shanghai", "Kaohsiung", "Melbourne", "Sydney", "Brisbane"],
    note: "North Asia / Japan / Korea coverage into East-coast Australia.",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Yokohama", "Melbourne", 23], ["Yokohama", "Sydney", 26], ["Yokohama", "Brisbane", 29],
        ["Osaka", "Melbourne", 22], ["Osaka", "Sydney", 25], ["Osaka", "Brisbane", 28],
        ["Pusan", "Melbourne", 20], ["Pusan", "Sydney", 23], ["Pusan", "Brisbane", 26],
        ["Qingdao", "Melbourne", 17], ["Qingdao", "Sydney", 20], ["Qingdao", "Brisbane", 23],
        ["Shanghai", "Melbourne", 14], ["Shanghai", "Sydney", 17], ["Shanghai", "Brisbane", 20],
        ["Kaohsiung", "Melbourne", 12], ["Kaohsiung", "Sydney", 15], ["Kaohsiung", "Brisbane", 18] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Sydney", "Yokohama", 14], ["Sydney", "Shanghai", 23], ["Sydney", "Kaohsiung", 25],
        ["Melbourne", "Yokohama", 17], ["Melbourne", "Shanghai", 26], ["Melbourne", "Kaohsiung", 28],
        ["Brisbane", "Yokohama", 11], ["Brisbane", "Shanghai", 20], ["Brisbane", "Kaohsiung", 22] ] },
    ],
  },
  {
    code: "A3C", name: "Asia Australia Consortium \u2014 Central Express", region: "Australia",
    freq: "Fixed-day weekly", round: "42-day round voyage", origins: ["Kaohsiung", "Xiamen", "Ningbo", "Shanghai"],
    nb: ["Sydney", "Melbourne", "Brisbane", "Kaohsiung", "Xiamen", "Ningbo", "Shanghai"],
    sb: ["Kaohsiung", "Xiamen", "Ningbo", "Shanghai", "Ningbo", "Sydney", "Melbourne", "Brisbane"],
    note: "Central China loop \u2014 fastest ex-Ningbo into Sydney (11 days).",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Kaohsiung", "Sydney", 19], ["Kaohsiung", "Melbourne", 23], ["Kaohsiung", "Brisbane", 29],
        ["Xiamen", "Sydney", 18], ["Xiamen", "Melbourne", 22], ["Xiamen", "Brisbane", 28],
        ["Shanghai", "Sydney", 13], ["Shanghai", "Melbourne", 17], ["Shanghai", "Brisbane", 23],
        ["Ningbo", "Sydney", 11], ["Ningbo", "Melbourne", 15], ["Ningbo", "Brisbane", 21] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Sydney", "Kaohsiung", 20], ["Sydney", "Xiamen", 21], ["Sydney", "Ningbo", 24], ["Sydney", "Shanghai", 26],
        ["Melbourne", "Kaohsiung", 16], ["Melbourne", "Xiamen", 17], ["Melbourne", "Ningbo", 20], ["Melbourne", "Shanghai", 22],
        ["Brisbane", "Kaohsiung", 11], ["Brisbane", "Xiamen", 12], ["Brisbane", "Ningbo", 15], ["Brisbane", "Shanghai", 17] ] },
    ],
  },
  {
    code: "AAA1", name: "Australia\u2013Asia Alliance Service (AAA1)", region: "Australia",
    freq: "Fixed-day weekly", round: "35-day round voyage", origins: ["Laem Chabang", "Singapore"],
    nb: ["Melbourne", "Sydney", "Brisbane", "Singapore", "Laem Chabang"],
    sb: ["Laem Chabang", "Singapore", "Melbourne", "Sydney", "Brisbane"],
    note: "Thailand direct service \u2014 Laem Chabang and Sydney on the same string (no vessel change at Singapore).",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Laem Chabang", "Melbourne", 13], ["Laem Chabang", "Sydney", 16], ["Laem Chabang", "Brisbane", 18],
        ["Singapore", "Melbourne", 10], ["Singapore", "Sydney", 13], ["Singapore", "Brisbane", 15] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Melbourne", "Singapore", 17], ["Melbourne", "Laem Chabang", 20],
        ["Sydney", "Singapore", 14], ["Sydney", "Laem Chabang", 17],
        ["Brisbane", "Singapore", 12], ["Brisbane", "Laem Chabang", 15] ] },
    ],
  },
  {
    code: "AAA2", name: "Australia\u2013Asia Alliance Service (AAA2)", region: "Australia",
    freq: "Fixed-day weekly", round: "35-day round voyage", origins: ["Singapore", "Port Kelang"],
    nb: ["Sydney", "Melbourne", "Adelaide", "Fremantle", "Singapore", "Port Kelang"],
    sb: ["Singapore", "Port Kelang", "Fremantle", "Sydney", "Melbourne", "Adelaide"],
    note: "Covers Fremantle (WA) & Adelaide (SA) via Singapore / Port Kelang transhipment.",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Singapore", "Fremantle", 8], ["Singapore", "Sydney", 14], ["Singapore", "Melbourne", 18], ["Singapore", "Adelaide", 21],
        ["Port Kelang", "Fremantle", 7], ["Port Kelang", "Sydney", 13], ["Port Kelang", "Melbourne", 17], ["Port Kelang", "Adelaide", 20] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Fremantle", "Singapore", 6], ["Fremantle", "Port Kelang", 8],
        ["Adelaide", "Singapore", 11], ["Adelaide", "Port Kelang", 13],
        ["Melbourne", "Singapore", 14], ["Melbourne", "Port Kelang", 16],
        ["Sydney", "Singapore", 17], ["Sydney", "Port Kelang", 19] ] },
    ],
  },
  {
    code: "ASA", name: "South East Asia \u2013 Australia Service Lane", region: "Australia",
    freq: "Fixed-day weekly", round: "35-day round voyage", origins: ["Jakarta", "Port Kelang", "Singapore"],
    nb: ["Brisbane", "Sydney", "Melbourne", "Adelaide", "Jakarta", "Port Kelang", "Singapore"],
    sb: ["Jakarta", "Port Kelang", "Singapore", "Brisbane", "Sydney", "Melbourne", "Adelaide"],
    note: "South-East Asia (Indonesia / Malaysia / Singapore) to East + South-coast Australia.",
    transits: [
      { title: "Asia \u2192 Australia (import)", rows: [
        ["Jakarta", "Brisbane", 16], ["Jakarta", "Sydney", 19], ["Jakarta", "Melbourne", 22], ["Jakarta", "Adelaide", 25],
        ["Port Kelang", "Brisbane", 13], ["Port Kelang", "Sydney", 16], ["Port Kelang", "Melbourne", 19], ["Port Kelang", "Adelaide", 22],
        ["Singapore", "Brisbane", 10], ["Singapore", "Sydney", 13], ["Singapore", "Melbourne", 16], ["Singapore", "Adelaide", 19] ] },
      { title: "Australia \u2192 Asia (export)", rows: [
        ["Adelaide", "Jakarta", 8], ["Adelaide", "Port Kelang", 11], ["Adelaide", "Singapore", 13],
        ["Melbourne", "Jakarta", 11], ["Melbourne", "Port Kelang", 14], ["Melbourne", "Singapore", 16],
        ["Sydney", "Jakarta", 14], ["Sydney", "Port Kelang", 17], ["Sydney", "Singapore", 19],
        ["Brisbane", "Jakarta", 17], ["Brisbane", "Port Kelang", 20], ["Brisbane", "Singapore", 22] ] },
    ],
  },
  {
    code: "AWX", name: "Australia West Coast Express", region: "Australia",
    freq: "Fixed-day weekly", round: "21-day round voyage", origins: ["Port Kelang", "Singapore"],
    sb: ["Port Kelang", "Singapore", "Fremantle"],
    nb: ["Fremantle", "Port Kelang", "Singapore"],
    note: "Dedicated fast service to Western Australia (Fremantle) \u2014 7 days ex-Singapore.",
    transits: [
      { title: "Asia \u2192 Fremantle (import)", rows: [
        ["Singapore", "Fremantle", 7], ["Port Kelang", "Fremantle", 9] ] },
      { title: "Fremantle \u2192 Asia (export)", rows: [
        ["Fremantle", "Port Kelang", 7], ["Fremantle", "Singapore", 9] ] },
    ],
  },
  {
    code: "NZS", name: "New Zealand / South East Asia Express", region: "New Zealand",
    freq: "Fixed-day weekly", round: "42-day round voyage", origins: ["Port Kelang", "Singapore"],
    sb: ["Port Kelang", "Singapore", "Auckland", "Lyttelton", "Wellington", "Napier", "Tauranga"],
    nb: ["Auckland", "Lyttelton", "Wellington", "Napier", "Tauranga", "Port Kelang"],
    note: "South-East Asia to all major New Zealand ports.",
    transits: [
      { title: "SE Asia \u2192 New Zealand (import)", rows: [
        ["Singapore", "Auckland", 14], ["Singapore", "Lyttelton", 17], ["Singapore", "Wellington", 19], ["Singapore", "Napier", 20], ["Singapore", "Tauranga", 21],
        ["Port Kelang", "Auckland", 16], ["Port Kelang", "Lyttelton", 19], ["Port Kelang", "Wellington", 21], ["Port Kelang", "Napier", 22], ["Port Kelang", "Tauranga", 23] ] },
      { title: "New Zealand \u2192 SE Asia (export)", rows: [
        ["Auckland", "Port Kelang", 24], ["Auckland", "Singapore", 25],
        ["Lyttelton", "Port Kelang", 21], ["Lyttelton", "Singapore", 22],
        ["Wellington", "Port Kelang", 20], ["Wellington", "Singapore", 21],
        ["Napier", "Port Kelang", 18], ["Napier", "Singapore", 19],
        ["Tauranga", "Port Kelang", 17], ["Tauranga", "Singapore", 18] ] },
    ],
  },
  {
    code: "CNS", name: "China \u2013 New Zealand Service", region: "New Zealand",
    freq: "Fixed-day weekly", round: "49-day round voyage", origins: ["Shanghai", "Ningbo", "Shekou", "Kaohsiung", "Hong Kong", "Keelung"],
    sb: ["Shanghai", "Ningbo", "Shekou", "Kaohsiung", "Auckland", "Lyttelton", "Wellington", "Napier", "Tauranga"],
    nb: ["Auckland", "Lyttelton", "Wellington", "Napier", "Tauranga", "Hong Kong", "Keelung", "Shanghai"],
    note: "Direct China coverage to all major New Zealand ports.",
    transits: [
      { title: "China \u2192 New Zealand (import)", rows: [
        ["Kaohsiung", "Auckland", 15], ["Kaohsiung", "Lyttelton", 19], ["Kaohsiung", "Wellington", 20], ["Kaohsiung", "Napier", 22], ["Kaohsiung", "Tauranga", 24],
        ["Shekou", "Auckland", 17], ["Shekou", "Lyttelton", 20], ["Shekou", "Wellington", 22], ["Shekou", "Napier", 23], ["Shekou", "Tauranga", 25],
        ["Ningbo", "Auckland", 20], ["Ningbo", "Lyttelton", 24], ["Ningbo", "Wellington", 25], ["Ningbo", "Napier", 27], ["Ningbo", "Tauranga", 29],
        ["Shanghai", "Auckland", 22], ["Shanghai", "Lyttelton", 25], ["Shanghai", "Wellington", 26], ["Shanghai", "Napier", 28], ["Shanghai", "Tauranga", 30] ] },
      { title: "New Zealand \u2192 China (export)", rows: [
        ["Auckland", "Hong Kong", 21], ["Auckland", "Shanghai", 25], ["Auckland", "Shekou", 30],
        ["Wellington", "Hong Kong", 17], ["Wellington", "Shanghai", 21], ["Wellington", "Shekou", 26],
        ["Tauranga", "Hong Kong", 14], ["Tauranga", "Shanghai", 18], ["Tauranga", "Shekou", 23] ] },
    ],
  },
  {
    code: "JKN", name: "North Asia Express (JKN)", region: "Australia & New Zealand",
    freq: "Fixed-day weekly", round: "42-day round voyage", origins: ["Tokyo", "Kobe", "Busan", "Shanghai", "Yantian", "Hong Kong"],
    nb: ["Brisbane", "Auckland", "Lyttelton", "Napier", "Tauranga", "Tokyo", "Kobe", "Busan", "Shanghai", "Yantian", "Hong Kong"],
    sb: ["Tokyo", "Kobe", "Busan", "Shanghai", "Yantian", "Hong Kong", "Brisbane", "Auckland", "Lyttelton", "Napier", "Tauranga"],
    note: "North Asia (Japan/Korea/China) to Brisbane + New Zealand.",
    transits: [
      { title: "Asia \u2192 Australia / New Zealand (import)", rows: [
        ["Hong Kong", "Brisbane", 10], ["Hong Kong", "Auckland", 15], ["Hong Kong", "Tauranga", 22],
        ["Yantian", "Brisbane", 11], ["Yantian", "Auckland", 16], ["Yantian", "Tauranga", 23],
        ["Shanghai", "Brisbane", 13], ["Shanghai", "Auckland", 18], ["Shanghai", "Tauranga", 25],
        ["Busan", "Brisbane", 15], ["Busan", "Auckland", 20], ["Busan", "Tauranga", 27],
        ["Tokyo", "Brisbane", 18], ["Tokyo", "Auckland", 23], ["Tokyo", "Tauranga", 30] ] },
      { title: "Australia / New Zealand \u2192 Asia (export)", rows: [
        ["Brisbane", "Tokyo", 22], ["Brisbane", "Shanghai", 27], ["Brisbane", "Hong Kong", 31],
        ["Auckland", "Tokyo", 17], ["Auckland", "Shanghai", 22], ["Auckland", "Hong Kong", 26],
        ["Tauranga", "Tokyo", 11], ["Tauranga", "Shanghai", 16], ["Tauranga", "Hong Kong", 20] ] },
    ],
  },
  {
    code: "ANS", name: "Australia \u2013 New Zealand Service", region: "Trans-Tasman",
    freq: "3 sailings per month", round: "Trans-Tasman shuttle", origins: [],
    nb: ["Melbourne", "Bell Bay", "Sydney", "Auckland", "Tauranga"],
    sb: ["Auckland", "Tauranga", "Melbourne", "Bell Bay", "Sydney"],
    note: "Trans-Tasman link \u2014 mainland Australia & Tasmania (Bell Bay) to NZ North Island.",
    transits: [
      { title: "Australia \u2192 New Zealand", rows: [
        ["Sydney", "Auckland", 5], ["Sydney", "Tauranga", 7],
        ["Bell Bay", "Auckland", 8], ["Bell Bay", "Tauranga", 10],
        ["Melbourne", "Auckland", 11], ["Melbourne", "Tauranga", 13] ] },
      { title: "New Zealand \u2192 Australia", rows: [
        ["Tauranga", "Melbourne", 6], ["Tauranga", "Bell Bay", 9], ["Tauranga", "Sydney", 12],
        ["Auckland", "Melbourne", 8], ["Auckland", "Bell Bay", 11], ["Auckland", "Sydney", 14] ] },
    ],
  },
];
